export default __webpack_public_path__ + "static/media/art-0-shape.c1d82ae4.jpeg";